import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {withRouter} from 'react-router';
import * as actions from '../../../../../store/actions';

import { Spinner } from 'react-bootstrap'
import FieldInput from '../../../../../components/FieldInput/FieldInput';
import Button from '../../../../../components/Button/Button';
import SweetAlert from 'react-bootstrap-sweetalert';

const RecoveryPassword = (props) => {
  const { t } = useTranslation();

  const [email, setEmail] = useState('')
  let [isLoading, setLoading] = useState(false)


  const dispatch = useDispatch();
  const onSubmit = (data) => {
    let params = {lang: 'en'}
    let lang = localStorage.getItem('language');

    if (lang !== null) {
      params = {lang: lang}
    }

    dispatch(actions.recoveryPassword(data,params))
    setInterval(()=> {
      setLoading(false)
    }, 500)
  };

  const submitHandler = event => {
    event.preventDefault();
    setLoading(true)
    onSubmit(email);
  };

  const response = useSelector(state => state.user.authResponse)
  const errors = response && response.errors
  const [isShowAlert, setShowAlert] = useState(false)


  const closeAlert = () => {
    dispatch(actions.setAuthResponse(null))
    props.history.push('/login')
  }

  useEffect(() => {
    if (response) {
      setShowAlert(response.success)
    }
  }, [response])

  return (
    <form className='login__form' onSubmit={submitHandler}>
      <FieldInput
        id="login-email"
        placeholder={t('login.inputEmail')}
        value={email}
        login
        inputHandler={() => e => setEmail(e.target.value)}
      />
      {   errors &&  errors.email ? <small className="text-danger ml-3">{errors.email}</small> : null }
      <div className='login__details align-items-center'>
        <Button inputType='submit' size='small'>
          {
            isLoading ?
            <span>
              <Spinner size="small" className="mr-2" animation="border" role="status"/>
            </span>
            : 'Submit'
          }
        </Button>
        <Link to='/login'>{t('general.backTo')} Login</Link>
      </div>
      <SweetAlert
        type="success"
        title={t('general.success')}
        show={isShowAlert}
        onConfirm={closeAlert}
      >
        {t('login.requestRecoverySuccess')}
      </SweetAlert>
    </form>
  );
};

export default withRouter(RecoveryPassword);
